import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'cupones-usados/';

export interface CuponUsado {
    id: number;
    cliente: number;
    cliente_nombre: string;
    cupon: number;
    cupon_codigo: string;
    cupon_descuento_monto: number | null;
    cupon_descuento_porcentaje: number | null;
    cita: number | null;
    cita_id: number | null;
    fecha_uso: string;
    fecha_creacion: string;
}



// GET: Obtener todos los cupones usados (admin o revisión)
export const fetchCuponesUsados = async (): Promise<CuponUsado[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<CuponUsado[]>(API_URL);
        return response.data;
    });
};

// GET: Obtener cupones usados por un cliente
export const fetchCuponesUsadosPorCliente = async (clienteId: number): Promise<CuponUsado[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<CuponUsado[]>(`${API_URL}?cliente_id=${clienteId}`);
        return response.data;
    });
};

// POST: Registrar uso manual (no se recomienda si ya lo haces en backend de cita)
export const registrarCuponUsado = async (data: {
    cliente: number;
    cupon: number;
    cita?: number;
}) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// DELETE: Eliminar un registro (solo para debugging o admin)
export const deleteCuponUsado = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};
